module.exports = __webpack_public_path__ + "img/fac4306d503640d68a5ac3da08e63829.b704cb3c.png";